import { render, staticRenderFns } from "./TopicModelItem.vue?vue&type=template&id=09eb4cb2&"
import script from "./TopicModelItem.vue?vue&type=script&lang=js&"
export * from "./TopicModelItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicModelItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports